import { byRegion } from 'app/shared-components/region';

export interface CarouselSlide {
  image: string;
  title: string;
  subtitle: string;
}

const IMAGES = '/assets/images/plus-websites';

// Canada pitches the builder from its own designs. The opening slide leads on the pharmacy's own
// domain rather than the component library, and slide two carries Canadian artwork showing the
// service cards those pharmacies actually drag around — prescription refills, vaccinations and
// minor ailments. Everything without a `canada` entry is shared with the UK.
export const CAROUSEL_SLIDES: CarouselSlide[] = [
  {
    image: `${IMAGES}/slide-1.webp`,
    title: byRegion({ uk: 'Components designed for pharmacies', canada: 'Your branded website' }),
    subtitle: byRegion({
      uk: 'Connect your services to your patients in seconds',
      canada: 'On your own domain, live in days',
    }),
  },
  {
    image: byRegion({ uk: `${IMAGES}/slide-2.png`, canada: `${IMAGES}/slide-2-ca.png` }),
    title: 'Modify',
    subtitle: byRegion({
      uk: 'Easy to use drag n drop editor',
      canada: 'Easy-to-use drag-and-drop editor',
    }),
  },
  {
    image: `${IMAGES}/slide-3.png`,
    title: 'Customize',
    subtitle: 'Apply your guidelines and visual language',
  },
  {
    image: byRegion({ uk: `${IMAGES}/slide-4.png`, canada: `${IMAGES}/slide-4-ca.png` }),
    title: 'SEO optimized',
    subtitle: byRegion({
      uk: 'Show up in search results without the extra work - SEO is built in.',
      canada: 'Show up in search results without the extra work — SEO is built in.',
    }),
  },
  // Canada's carousel ends on the SEO slide. The flows pitch names the OTC store, which Canada
  // does not sell — the same reason SALES_FEATURES leaves e-commerce out there.
  ...byRegion<CarouselSlide[]>({
    uk: [
      {
        image: `${IMAGES}/slide-5.png`,
        title: 'All flows built in',
        subtitle: 'Prescriptions, service & clinic bookings, OTC e-commerce',
      },
    ],
    canada: [],
  }),
];
